import { useQuery, useMutation, useQueryClient } from 'react-query';
import { GetLeads, GetLeadById, AddNewLead, UpdateLead, DeleteLead } from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetLeads(filter = {}) {
    return useQuery(['leads', filter], () => GetLeads(filter), {
        refetchOnWindowFocus: true,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data || [];
        },
        onError: (error) => {
            NotifyError('Failed to fetch leads', error);
            console.error('Error fetching leads:', error);
        }
    });
}
export function useGetLeadById(leadId) {
    return useQuery(
        ['lead', leadId],
        () => GetLeadById(leadId),
        {
            enabled: !!leadId,
            staleTime: 5 * 60 * 1000, // 5 minutes
            onError: (error) => {
                NotifyError('Failed to fetch lead details', error);
                console.error('Error fetching lead details:', error);
            }
        }
    );
}


export function useAddLead() {
    const queryClient = useQueryClient();
    return useMutation(AddNewLead, {
        onSuccess: () => {
            Notify('Lead added successfully');
            queryClient.invalidateQueries('leads');
        },
        onError: (error) => {
            NotifyError('Failed to add lead', error);
            console.error('Error adding lead:', error);
        }
    });
}

export function useUpdateLead() {
    const queryClient = useQueryClient();
    return useMutation(({ leadId, data }) => UpdateLead(leadId, data), {
        onSuccess: () => {
            Notify('Lead updated successfully');
            queryClient.invalidateQueries('leads');
        }
        ,
        onError: (error) => {
            NotifyError('Failed to update lead', error);
            console.error('Error updating lead:', error);
        }
    });
}

export function useDeleteLead() {
    const queryClient = useQueryClient();
    return useMutation(DeleteLead, {
        onSuccess: () => {
            Notify('Lead deleted successfully');
            queryClient.invalidateQueries('leads');
        },
        onError: (error) => {
            NotifyError('Failed to delete lead', error);
            console.error('Error deleting lead:', error);
        }
    });
}